import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller, useFormContext } from "react-hook-form"

const Input = ({
  label,
  id,
  className,
  maxLength,
  type,
  min,
  max,
  ...inputProps
}) => {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      name={id}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => {
        return (
          <div
            className={clsx(
              "flex flex-col relative mb-4 w-full",
              className && className,
            )}
          >
            <div className="flex justify-between items-center">
              <label
                htmlFor={id}
                className="mt-4 mb-2 text-xs text-brand-secondary font-semibold"
              >
                {label}
              </label>
              {maxLength && (
                <div>
                  <span
                    className={clsx(
                      value?.length <= maxLength
                        ? "text-[green]"
                        : "text-[red]",
                    )}
                  >
                    {value?.length || 0}
                  </span>
                  /{maxLength}
                </div>
              )}
            </div>
            <input
              onChange={(e) => {
                if (type === "number") {
                  const value = e.target.value
                  onChange(value === "" ? null : Number(value))
                } else {
                  onChange(e.target.value)
                }
              }}
              onBlur={onBlur}
              value={value}
              id={id}
              type={type ?? "text"}
              className="bg-gray1 h-8 rounded-lg px-4 text-[12px]"
              {...inputProps}
            />
            {error && (
              <p className="text-xs text-red-500 absolute -bottom-5">
                {error?.message}
              </p>
            )}
          </div>
        )
      }}
    />
  )
}

Input.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  type: PropTypes.string,
}

export default Input
